import { render, staticRenderFns } from "./useMange.vue?vue&type=template&id=96241de4&scoped=true&"
import script from "./useMange.vue?vue&type=script&lang=js&"
export * from "./useMange.vue?vue&type=script&lang=js&"
import style0 from "./useMange.vue?vue&type=style&index=0&id=96241de4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96241de4",
  null
  
)

export default component.exports